import { pageLayouts } from '../constants';
import cpdActivityCertificate from './cpd-activity-certificate';
import { downloadBlobStreamFile, getBlobStream, getPdfStream, writeDataToPdfStream } from '../utils';

const exportCpdCertificatePdf = async ({
  userName,
  activityContent,
  provider,
  providerLogo,
  cpdPointAllocation,
  cpdPoints,
  dateCompleted,
  contentId,
}) => {
  downloadBlobStreamFile(
    writeDataToPdfStream(
      getPdfStream({
        layout: pageLayouts.portrait,
        size: 'A4'
      }),
      await cpdActivityCertificate({
        userName: userName,
        contentTitle: activityContent,
        publisherName: provider,
        publisherLogo: providerLogo,
        cpdPointAllocation,
        totalPoints: cpdPoints,
        dateCompleted,
        contentId,
      }),
      false,
    ).pipe(getBlobStream()),
    `cpd-certificate.pdf`
  );
};

export default exportCpdCertificatePdf;


// WEBPACK FOOTER //
// ./src/reports/export-cpd-certificate-pdf.js